export default "__VITE_ASSET__BwvR7Zej__"